import { css } from "styled-components";
import reset from "styled-reset";

const Global = css`
  ${reset};
  html,
  body {
    font-size: ${props => props.theme.fontSizes.base}px;
    margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto",
      "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans",
      "Helvetica Neue", sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
      monospace;
  }

  * {
    box-sizing: border-box;
    padding: 0;
    margin: 0;
  }

  hr {
    margin-top: ${props => props.theme.sizes.huge}rem;
    margin-bottom: ${props => props.theme.sizes.huge}rem;
    height: 2px;
    border: none;
    background-color: ${props => props.theme.grayscale.g20};
    width: 100%;
  }
`;

export default Global;
